export default __webpack_public_path__ + "static/media/logo-noprogram.85a19fd1.svg";